import 'nodelist-foreach-polyfill'; // ie11

const ratio_height = (context, el, ratio, options) => {
  // let el = document.querySelector(query)
  if (!el) return
  let height = (el.offsetWidth * ratio) // .toFixed()

  // console.log(height) // todo: debug on IE11.

  let styles = {
    'height': height + 'px',
  }
  if (options) {
    if (options.override === true) {
      styles = {
        'height': 'auto'
      }
    }
  }

  
  context.ratio_styles = styles
}

const ratio_styles = {}

export {ratio_height, ratio_styles}


// WEBPACK FOOTER //
// ./src/utils/ratio_height.js